import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion'
import { fadeIn } from '../../variants';
import './HomePage.css'
import { Button } from '@mui/material';
import { useResponsiveQueries, S3_BASE_URL } from '../../utils/constants';

const HomeRow2 = () => {
  const { HEADER_MIN_WIDTH, MOBILE_WIDTH } = useResponsiveQueries();
  const [loadedImages, setLoadedImages] = useState({});
  const navigate = useNavigate();

  const handleNavigation = (value) => {
    navigate(value);
  };

  const handleImageLoad = (imageName) => {
    setLoadedImages((prev) => ({ ...prev, [imageName]: true }));
  };

  return (
    <div className='home-row2-container'>
      {!HEADER_MIN_WIDTH &&
        <motion.img
          variants={fadeIn("right", 0)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className={`image ${loadedImages.Girl1 ? 'loaded' : ''}`}
          src={`${S3_BASE_URL}/images/Girl1.webp`}
          alt='Girl1'
          loading='lazy'
          onLoad={() => handleImageLoad('Girl1')}></motion.img>
      }
      <div className='home-row2-description'>
        <motion.div
          variants={fadeIn("down", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='row-title' style={{ color: '#0D65D9', fontSize: 'clamp(40px, 7vw, 96px)', height: 'clamp(40px, 7vw, 96px)' }}
        >
          RESPONSIBLE GAMING
        </motion.div>
        <div className='home-row2-logo-container'>
          <img style={{ width: '24.6%', maxWidth: 224 }} src={`${S3_BASE_URL}/images/GamStop.webp`} alt='Gam Stop' loading='lazy' />
          <img style={{ width: '40.7%', maxWidth: 370 }} src={`${S3_BASE_URL}/images/GambleAware.webp`} alt='Gamble Aware' loading='lazy' />
          <img style={{ width: '21.4%', maxWidth: 195 }} src={`${S3_BASE_URL}/images/GamCare.webp`} alt='Gam Care' loading='lazy' />
        </div>
        <motion.div
          variants={fadeIn("left", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='description' style={{ textAlign: 'justify', height: 'auto', maxHeight: 312, fontSize: 'clamp(16px, 2vw, 24px)' }}>
          At 101 White Label, we don't just create world-class white label solutions for the international online casino market—we make
          "Responsible Gaming" our guiding principle in every endeavor. We understand that sustainable success comes not only from
          delivering exceptional entertainment experiences but also from ensuring players are always protected and supported.
          <br /><br />
          With 101 White Label, every product and service is designed to promote healthy gaming practices through close collaboration with
          player support organizations and initiatives that encourage safe and balanced gameplay. We continually strive to provide a safe,
          transparent, and responsible iGaming environment, helping our partners not only thrive but also contribute to building a civilized
          and sustainable player community.
        </motion.div>
        <Button
          id='action-button'
          sx={{ width: '100%', maxWidth: MOBILE_WIDTH ? '361px' : '184px', zIndex: 1 }}
          onClick={() => handleNavigation('/responsible-gaming')}
        >
          Find out more
        </Button>
      </div>
      {!HEADER_MIN_WIDTH &&
        <img className='image-bg' src={`${S3_BASE_URL}/images/Plus18.webp`} alt='Plus18' loading='lazy' />}
    </div>
  );
};

export default HomeRow2;